//---------- Compras -------------
import Solicitud_Compras_Servicio from "../../../views/administrador/Compras/Solicitud_Compras_Servicio";
import Solicitud_Compras from "../../../views/administrador/Compras/Solicitud_Compras";
import Solicitud_Compras_ADM from "../../../views/administrador/Compras/Solicitud_Compras_ADM";
import Solicitud_Compras_Servicio_ADM from "../../../views/administrador/Compras/Solicitud_Compras_Servicio_ADM";
import Informe_de_estatus_de_autorizacion from "../../../views/administrador/Compras/Informe_de_estatus_de_autorizacion";
import RequiAdjunto from "../../../views/administrador/Compras/RequiAdjunto";



const routes_compras = [
  {
    path: "/Solicitud_Compras_Servicio",
    name: "Solicitud de Servicio Preliminar",
    icon: "",
    component: Solicitud_Compras_Servicio,
    doNotShow: true,
  }, 
  {
    path: "/Solicitud_Compras",
    name: "Solicitud de Articulo Preliminar",
    icon: "",
    component: Solicitud_Compras,
    doNotShow: true,
  }, 
  {
    path: "/Solicitud_Compras_ADM",
    name: "Solicitud Compra por Articulo",
    icon: "",
    component: Solicitud_Compras_ADM,
    doNotShow: true,
  }, 
  {
    path: "/Solicitud_Compras_Servicio_ADM",
    name: "Solicitud Compra por Servicio",
    icon: "",
    component: Solicitud_Compras_Servicio_ADM,
    doNotShow: true,
  }, 
  {
    path: "/Informe_de_estatus_de_autorizacion",
    name: "Informe Status de Autorizacion",
    icon: "",
    component: Informe_de_estatus_de_autorizacion,
    doNotShow: true,
  },
   {
    path: "/RequiAdjunto",
    name: "Adjuntar Archivo Cotizacion",
    icon: "",
    component: RequiAdjunto,
    doNotShow: true,
  },
];

export default routes_compras;
